const LINK_PROGRAM_NAMES = {
  opportunity: 'Opportunity',
  spotlight: 'Spotlight',
  collaboration: 'Collaboration',
  gift: 'Gifting',
  code: 'Custom Code',
  rate: 'Custom Rate'
};

module.exports = { LINK_PROGRAM_NAMES };
